var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNl = function SvgNl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    viewBox: "0 0 900 780"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "nl_svg__a"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 390,
    r: 390
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#nl_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#21468B",
    d: "M0 0h900v780H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h900v520H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AE1C28",
    d: "M0 0h900v260H0z"
  }))));
};
export default SvgNl;